<mat-drawer-container class="md-container" autosize [hasBackdrop]="isMobile" (backdropClick)="drawer.close()">
    <mat-drawer #drawer class="example-sidenav" [mode]="isMobile ? 'over' : 'side'" [opened]="!isMobile">
        @if(user$ | async; as d){
        <div class="content-menu">
            <div class="icon-logo">
                <img width="30" [src]="iconUrl" alt="">
            </div>
            <a routerLink="/playground" mat-icon-button class="menu-item" routerLinkActive="activebutton" #tooltip="matTooltip"
                matTooltip="PlayGround" matTooltipPosition="left"
                *ngIf="d.roles?.admin || d.roles?.superadmin || d.roles?.viewer" (click)="closeIfMobile()">
                <span class="material-symbols-outlined">ar_stickers</span>
                <span class="menu-label">PlayGround</span>
            </a>
            <a routerLink="/missions" mat-icon-button class="menu-item" routerLinkActive="activebutton" #tooltip="matTooltip"
                matTooltip="Tareas" matTooltipPosition="left" *ngIf="d.roles?.admin || d.roles?.superadmin"
                (click)="closeIfMobile()">
                <span class="material-symbols-outlined">detection_and_zone</span>
                <span class="menu-label">Tareas</span>
            </a>
            <a routerLink="/rules" mat-icon-button class="menu-item" routerLinkActive="activebutton" #tooltip="matTooltip"
                matTooltip="Reglas" matTooltipPosition="left" *ngIf="d.roles?.admin || d.roles?.superadmin"
                (click)="closeIfMobile()">
                <span class="material-symbols-outlined">straighten</span>
                <span class="menu-label">Reglas</span>
            </a>
            <ng-container *ngIf="d.roles?.admin || d.roles?.superadmin || d.roles?.viewer">
                <button mat-icon-button class="menu-item" cdkOverlayOrigin #filesMenuOrigin="cdkOverlayOrigin"
                    [class.activebutton]="isGestionArchivosActive() || isSchemasAdminActive()"
                    matTooltip="Archivos y Schemas" matTooltipPosition="left" [matTooltipDisabled]="openFlyoutKey === 'files'"
                    (mouseenter)="openFlyout('files')" (mouseleave)="scheduleCloseFlyout()">
                    <span class="material-symbols-outlined">database</span>
                    <span class="menu-label">Archivos y Schemas</span>
                </button>

                <ng-template
                    cdkConnectedOverlay
                    [cdkConnectedOverlayOrigin]="filesMenuOrigin"
                    [cdkConnectedOverlayOpen]="openFlyoutKey === 'files'"
                    [cdkConnectedOverlayPositions]="flyoutPositions"
                    [cdkConnectedOverlayHasBackdrop]="false"
                    (overlayOutsideClick)="openFlyoutKey = null">
                    <div class="hover-flyout-panel" (mouseenter)="cancelCloseFlyout()" (mouseleave)="scheduleCloseFlyout()">
                        <a routerLink="/schemas" class="flyout-item" [class.activebutton]="isGestionArchivosActive()" (click)="openFlyoutKey = null; closeIfMobile()">
                            <span class="material-symbols-outlined">files</span>
                            <span>Gestión de archivos</span>
                        </a>
                        <a routerLink="/schemas-admin" class="flyout-item" [class.activebutton]="isSchemasAdminActive()" (click)="openFlyoutKey = null; closeIfMobile()">
                            <span class="material-symbols-outlined">table_rows</span>
                            <span>Schemas admin</span>
                        </a>
                    </div>
                </ng-template>
            </ng-container>
            <!-- <a routerLink="/schema-rules" mat-icon-button class="menu-item" [class.activebutton]="isSchemaRulesActive()" #tooltip="matTooltip"
                matTooltip="Reglas de schemas" matTooltipPosition="left" *ngIf="d.roles?.admin || d.roles?.superadmin"
                (click)="closeIfMobile()">
                <span class="material-symbols-outlined">rule_folder</span>
                <span class="menu-label">Reglas schemas</span>
            </a> -->
            <a routerLink="/dashboards" mat-icon-button class="menu-item" routerLinkActive="activebutton" #tooltip="matTooltip"
                matTooltip="Dashboards" matTooltipPosition="left" *ngIf="d.roles?.admin || d.roles?.superadmin"
                (click)="closeIfMobile()">
                <span class="material-symbols-outlined">dashboard_2</span>
                <span class="menu-label">Dashboards</span>
            </a>
            <a routerLink="/models" mat-icon-button class="menu-item" routerLinkActive="activebutton" #tooltip="matTooltip"
                matTooltip="Modelos" matTooltipPosition="left" *ngIf="d.roles?.admin || d.roles?.superadmin"
                (click)="closeIfMobile()">
                <span class="material-symbols-outlined">smart_toy</span>
                <span class="menu-label">Modelos</span>
            </a>
            <a mat-icon-button class="menu-item" routerLink="/users" routerLinkActive="activebutton"
                matTooltipPosition="left" matTooltip="Usuarios" *ngIf="d.roles?.admin || d.roles?.superadmin"
                (click)="closeIfMobile()">
                <span class="material-symbols-outlined">
                    group
                </span>
                <span class="menu-label">Usuarios</span>
            </a>
            <a mat-icon-button class="menu-item" routerLink="/clients" routerLinkActive="activebutton"
                matTooltipPosition="left" matTooltip="Clientes" *ngIf="d.roles?.admin || d.roles?.superadmin"
                (click)="closeIfMobile()">
                <span class="material-symbols-outlined">
                    patient_list
                </span>
                <span class="menu-label">Clientes</span>
            </a>
            <ng-container *ngIf="d.roles?.admin || d.roles?.superadmin">
                <button mat-icon-button class="menu-item" cdkOverlayOrigin #productsMenuOrigin="cdkOverlayOrigin"
                    [class.activebutton]="isProductsActive()"
                    matTooltip="Productos" matTooltipPosition="left" [matTooltipDisabled]="openFlyoutKey === 'products'"
                    (mouseenter)="openFlyout('products')" (mouseleave)="scheduleCloseFlyout()">
                    <span class="material-symbols-outlined">menu</span>
                    <span class="menu-label">Productos</span>
                </button>

                <ng-template
                    cdkConnectedOverlay
                    [cdkConnectedOverlayOrigin]="productsMenuOrigin"
                    [cdkConnectedOverlayOpen]="openFlyoutKey === 'products'"
                    [cdkConnectedOverlayPositions]="flyoutPositions"
                    [cdkConnectedOverlayHasBackdrop]="false"
                    (overlayOutsideClick)="openFlyoutKey = null">
                    <div class="hover-flyout-panel" (mouseenter)="cancelCloseFlyout()" (mouseleave)="scheduleCloseFlyout()">
                        <a routerLink="/library-attributes" class="flyout-item" routerLinkActive="activebutton" (click)="openFlyoutKey = null; closeIfMobile()">
                            <span class="material-symbols-outlined">edit_attributes</span>
                            <span>Atributos</span>
                        </a>
                        <a routerLink="/library-objects" class="flyout-item" routerLinkActive="activebutton" (click)="openFlyoutKey = null; closeIfMobile()">
                            <span class="material-symbols-outlined">local_library</span>
                            <span>Libreria</span>
                        </a>
                    </div>
                </ng-template>
            </ng-container>

            <a mat-icon-button class="menu-item" routerLink="/cvat/projects" routerLinkActive="activebutton"
                matTooltipPosition="left" matTooltip="Cvat" *ngIf="d.roles?.admin || d.roles?.superadmin"
                (click)="closeIfMobile()">
                <span class="material-symbols-outlined">
                    task
                </span>
                <span class="menu-label">Cvat</span>
            </a>
            <a mat-icon-button class="menu-item" routerLink="/boards" routerLinkActive="activebutton"
                matTooltipPosition="left" matTooltip="DashBoards" (click)="closeIfMobile()">
                <span class="material-symbols-outlined">dashboard</span>
                <span class="menu-label">DashBoards</span>
            </a>
            <button mat-icon-button class="menu-item" (click)="signOut(); closeIfMobile()" routerLinkActive="activebutton"
                matTooltipPosition="left" matTooltip="Salir">
                <span class="material-symbols-outlined">logout</span>
                <span class="menu-label">Salir</span>
            </button>
        </div>
        }
    </mat-drawer>
    <mat-drawer-content class="example-sidenav-content">
        <router-outlet></router-outlet>

        @if(iconview){
        <div class="client-init">
            <img height="80" [src]="logoUrl" alt="">
            <mat-spinner diameter="20" strokeWidth="1"></mat-spinner>
        </div>
        }


    </mat-drawer-content>
</mat-drawer-container>
